/**
 * Copyright (C) 2019 Egylis,
 * Siège social, 83 bis rue de l'Abbé Groult, 75015 Paris - France.
 * All Rights Reserved.
 *
 * E-mail : info@egylis.com
 *
 * This software is the confidential and proprietary information
 * of Egylis. ("Confidential Information"). You shall not
 * disclose such Confidential Information and shall use it only
 * in accordance with the terms of the license agreement you
 * entered into with Egylis.
 *
 * Created on Mon Feb 28 2022 16:48:22 GMT+0100 (heure normale d’Europe centrale).
 *
 * Version : Generator 2.0.9 / Datatable 1.0.1
 */

import {MOEntityMeta} from './MOEntityMeta';
import {ColumnType, MetaColumn, MetaIndex} from '../defEntity/';
import {RouleauNote} from '../entity';

/**
 * Notes des Rouleaux Meta Entity.
 */
export class RouleauNoteMeta implements MOEntityMeta<RouleauNote> {
    /**
     * Instance
     */
    private static _instance: RouleauNoteMeta = new RouleauNoteMeta();
    /**
     * Class.
     */
    private _classEntity: new(...args: any[]) => RouleauNote = RouleauNote;
    /**
     * Table Name
     */
    private _tableName: string = 'lemken_rouleaux_201907_rouleaux_notes';
    /**
     * Sync Data Server to Client
     */
    private _syncDataServerToClient: boolean = true;
    /**
     * Sync Data Client to Server
     */
    private _syncDataClientToServer: boolean = false;
    /**
     * Sync File Server to Client
     */
    private _syncFileServerToClient: boolean = true;
    /**
     * Sync File Client to Server
     */
    private _syncFileClientToServer: boolean = false;
    /**
     * Uuid
     */
    private _uuid: MetaColumn = {
        name        : '_uuid',
        type        : ColumnType.UUID,
        propertyName: '_uuid',
        primaryKey  : true
    };
    /**
     * Status
     */
    private _status: MetaColumn = {
        name        : '_status',
        type        : ColumnType.STATUS,
        propertyName: '_status',
    };
    /**
     * Timestamp
     */
    private _timeStamp: MetaColumn = {
        name        : '_time_stamp',
        type        : ColumnType.TIMESTAMP,
        propertyName: '_timeStamp',
    };
    /**
     * previous Server Id
     */
    private ___previousServerId: MetaColumn = {
        name        : '___previousServerId',
        type        : ColumnType.INTEGER,
        propertyName: '___previousServerId',
    };
    /**
     * Is New
     */
    private ___isNew: MetaColumn = {
        name        : '___isNew',
        type        : ColumnType.BOOLEAN,
        propertyName: '___isNew',
    };

    /**
     * Code Rouleau
     */
    private _codeRouleau: MetaColumn = {
        name        : 'code_rouleau',
        type        : ColumnType.STRING,
        propertyName: '_codeRouleau',
        size        : 64,
        index       : false
    };
    /**
     * Note sol lourd rappuyage en ligne
     */
    private _solLourdRappuyageLigne: MetaColumn = {
        name        : 'sol_lourd_rappuyage_ligne',
        type        : ColumnType.INTEGER,
        propertyName: '_solLourdRappuyageLigne',
        size        : 8,
        index       : false
    };
    /**
     * Note sol lourd insensible aucollage
     */
    private _solLourdInsCollage: MetaColumn = {
        name        : 'sol_lourd_ins_collage',
        type        : ColumnType.INTEGER,
        propertyName: '_solLourdInsCollage',
        size        : 8,
        index       : false
    };
    /**
     * Note sol lourd insensible aux pierres
     */
    private _solLourdInsPierres: MetaColumn = {
        name        : 'sol_lourd_ins_pierres',
        type        : ColumnType.INTEGER,
        propertyName: '_solLourdInsPierres',
        size        : 8,
        index       : false
    };
    /**
     * Note sol lourd nivellement
     */
    private _solLourdNivellement: MetaColumn = {
        name        : 'sol_lourd_nivellement',
        type        : ColumnType.INTEGER,
        propertyName: '_solLourdNivellement',
        size        : 8,
        index       : false
    };
    /**
     * Note sol lourd contrôle profondeur
     */
    private _solLourdCtrlProf: MetaColumn = {
        name        : 'sol_lourd_ctrl_prof',
        type        : ColumnType.INTEGER,
        propertyName: '_solLourdCtrlProf',
        size        : 8,
        index       : false
    };
    /**
     * Note sol lourd rappuyage
     */
    private _solLourdRappuyage: MetaColumn = {
        name        : 'sol_lourd_rappuyage',
        type        : ColumnType.INTEGER,
        propertyName: '_solLourdRappuyage',
        size        : 8,
        index       : false
    };
    /**
     * Note sol lourd roulage
     */
    private _solLourdRoulage: MetaColumn = {
        name        : 'sol_lourd_roulage',
        type        : ColumnType.INTEGER,
        propertyName: '_solLourdRoulage',
        size        : 8,
        index       : false
    };
    /**
     * Note sol lourd emiettement
     */
    private _solLourdEmiettement: MetaColumn = {
        name        : 'sol_lourd_emiettement',
        type        : ColumnType.INTEGER,
        propertyName: '_solLourdEmiettement',
        size        : 8,
        index       : false
    };
    /**
     * Note sol moyen rappuyage en ligne
     */
    private _solMoyenRappuyageLigne: MetaColumn = {
        name        : 'sol_moyen_rappuyage_ligne',
        type        : ColumnType.INTEGER,
        propertyName: '_solMoyenRappuyageLigne',
        size        : 8,
        index       : false
    };
    /**
     * Note sol moyen insensible aucollage
     */
    private _solMoyenInsCollage: MetaColumn = {
        name        : 'sol_moyen_ins_collage',
        type        : ColumnType.INTEGER,
        propertyName: '_solMoyenInsCollage',
        size        : 8,
        index       : false
    };
    /**
     * Note sol moyen insensible aux pierres
     */
    private _solMoyenInsPierres: MetaColumn = {
        name        : 'sol_moyen_ins_pierres',
        type        : ColumnType.INTEGER,
        propertyName: '_solMoyenInsPierres',
        size        : 8,
        index       : false
    };
    /**
     * Note sol moyen nivellement
     */
    private _solMoyenNivellement: MetaColumn = {
        name        : 'sol_moyen_nivellement',
        type        : ColumnType.INTEGER,
        propertyName: '_solMoyenNivellement',
        size        : 8,
        index       : false
    };
    /**
     * Note sol moyen contrôle profondeur
     */
    private _solMoyenCtrlProf: MetaColumn = {
        name        : 'sol_moyen_ctrl_prof',
        type        : ColumnType.INTEGER,
        propertyName: '_solMoyenCtrlProf',
        size        : 8,
        index       : false
    };
    /**
     * Note sol moyen rappuyage
     */
    private _solMoyenRappuyage: MetaColumn = {
        name        : 'sol_moyen_rappuyage',
        type        : ColumnType.INTEGER,
        propertyName: '_solMoyenRappuyage',
        size        : 8,
        index       : false
    };
    /**
     * Note sol moyen roulage
     */
    private _solMoyenRoulage: MetaColumn = {
        name        : 'sol_moyen_roulage',
        type        : ColumnType.INTEGER,
        propertyName: '_solMoyenRoulage',
        size        : 8,
        index       : false
    };
    /**
     * Note sol moyen emiettement
     */
    private _solMoyenEmiettement: MetaColumn = {
        name        : 'sol_moyen_emiettement',
        type        : ColumnType.INTEGER,
        propertyName: '_solMoyenEmiettement',
        size        : 8,
        index       : false
    };
    /**
     * Note sol léger rappuyage en ligne
     */
    private _solLegerRappuyageLigne: MetaColumn = {
        name        : 'sol_leger_rappuyage_ligne',
        type        : ColumnType.INTEGER,
        propertyName: '_solLegerRappuyageLigne',
        size        : 8,
        index       : false
    };
    /**
     * Note sol léger insensible aucollage
     */
    private _solLegerInsCollage: MetaColumn = {
        name        : 'sol_leger_ins_collage',
        type        : ColumnType.INTEGER,
        propertyName: '_solLegerInsCollage',
        size        : 8,
        index       : false
    };
    /**
     * Note sol léger insensible aux pierres
     */
    private _solLegerInsPierres: MetaColumn = {
        name        : 'sol_leger_ins_pierres',
        type        : ColumnType.INTEGER,
        propertyName: '_solLegerInsPierres',
        size        : 8,
        index       : false
    };
    /**
     * Note sol léger nivellement
     */
    private _solLegerNivellement: MetaColumn = {
        name        : 'sol_leger_nivellement',
        type        : ColumnType.INTEGER,
        propertyName: '_solLegerNivellement',
        size        : 8,
        index       : false
    };
    /**
     * Note sol léger contrôle profondeur
     */
    private _solLegerCtrlProf: MetaColumn = {
        name        : 'sol_leger_ctrl_prof',
        type        : ColumnType.INTEGER,
        propertyName: '_solLegerCtrlProf',
        size        : 8,
        index       : false
    };
    /**
     * Note sol léger rappuyage
     */
    private _solLegerRappuyage: MetaColumn = {
        name        : 'sol_leger_rappuyage',
        type        : ColumnType.INTEGER,
        propertyName: '_solLegerRappuyage',
        size        : 8,
        index       : false
    };
    /**
     * Note sol léger roulage
     */
    private _solLegerRoulage: MetaColumn = {
        name        : 'sol_leger_roulage',
        type        : ColumnType.INTEGER,
        propertyName: '_solLegerRoulage',
        size        : 8,
        index       : false
    };
    /**
     * Note sol léger emiettement
     */
    private _solLegerEmiettement: MetaColumn = {
        name        : 'sol_leger_emiettement',
        type        : ColumnType.INTEGER,
        propertyName: '_solLegerEmiettement',
        size        : 8,
        index       : false
    };
    /**
     * Note moyenne rappuyage en ligne
     */
    private _generalRappuyageLigne: MetaColumn = {
        name        : 'general_rappuyage_ligne',
        type        : ColumnType.INTEGER,
        propertyName: '_generalRappuyageLigne',
        size        : 8,
        index       : false
    };
    /**
     * Note moyenne insensible aucollage
     */
    private _generalInsCollage: MetaColumn = {
        name        : 'general_ins_collage',
        type        : ColumnType.INTEGER,
        propertyName: '_generalInsCollage',
        size        : 8,
        index       : false
    };
    /**
     * Note moyenne insensible aux pierres
     */
    private _generalInsPierres: MetaColumn = {
        name        : 'general_ins_pierres',
        type        : ColumnType.INTEGER,
        propertyName: '_generalInsPierres',
        size        : 8,
        index       : false
    };
    /**
     * Note moyenne nivellement
     */
    private _generalNivellement: MetaColumn = {
        name        : 'general_nivellement',
        type        : ColumnType.INTEGER,
        propertyName: '_generalNivellement',
        size        : 8,
        index       : false
    };
    /**
     * Note moyenne contrôle profondeur
     */
    private _generalCtrlProf: MetaColumn = {
        name        : 'general_ctrl_prof',
        type        : ColumnType.INTEGER,
        propertyName: '_generalCtrlProf',
        size        : 8,
        index       : false
    };
    /**
     * Note moyenne rappuyage
     */
    private _generalRappuyage: MetaColumn = {
        name        : 'general_rappuyage',
        type        : ColumnType.INTEGER,
        propertyName: '_generalRappuyage',
        size        : 8,
        index       : false
    };
    /**
     * Note moyenne roulage
     */
    private _generalRoulage: MetaColumn = {
        name        : 'general_roulage',
        type        : ColumnType.INTEGER,
        propertyName: '_generalRoulage',
        size        : 8,
        index       : false
    };
    /**
     * Note moyenne emiettement
     */
    private _generalEmiettement: MetaColumn = {
        name        : 'general_emiettement',
        type        : ColumnType.INTEGER,
        propertyName: '_generalEmiettement',
        size        : 8,
        index       : false
    };


    /**
     * uuid Index
     */
    private _uuidIndex: MetaIndex = new MetaIndex('_uuid');

    /**
     * Columns
     */
    private _columns: { [key: string]: MetaColumn; } = {
        _uuid                                   : this._uuid,
        _status                                 : this._status,
        _timeStamp                              : this._timeStamp,
        ___previousServerId                     : this.___previousServerId,
        ___isNew                                : this.___isNew,
        _codeRouleau                            : this._codeRouleau,
        _solLourdRappuyageLigne                 : this._solLourdRappuyageLigne,
        _solLourdInsCollage                     : this._solLourdInsCollage,
        _solLourdInsPierres                     : this._solLourdInsPierres,
        _solLourdNivellement                    : this._solLourdNivellement,
        _solLourdCtrlProf                       : this._solLourdCtrlProf,
        _solLourdRappuyage                      : this._solLourdRappuyage,
        _solLourdRoulage                        : this._solLourdRoulage,
        _solLourdEmiettement                    : this._solLourdEmiettement,
        _solMoyenRappuyageLigne                 : this._solMoyenRappuyageLigne,
        _solMoyenInsCollage                     : this._solMoyenInsCollage,
        _solMoyenInsPierres                     : this._solMoyenInsPierres,
        _solMoyenNivellement                    : this._solMoyenNivellement,
        _solMoyenCtrlProf                       : this._solMoyenCtrlProf,
        _solMoyenRappuyage                      : this._solMoyenRappuyage,
        _solMoyenRoulage                        : this._solMoyenRoulage,
        _solMoyenEmiettement                    : this._solMoyenEmiettement,
        _solLegerRappuyageLigne                 : this._solLegerRappuyageLigne,
        _solLegerInsCollage                     : this._solLegerInsCollage,
        _solLegerInsPierres                     : this._solLegerInsPierres,
        _solLegerNivellement                    : this._solLegerNivellement,
        _solLegerCtrlProf                       : this._solLegerCtrlProf,
        _solLegerRappuyage                      : this._solLegerRappuyage,
        _solLegerRoulage                        : this._solLegerRoulage,
        _solLegerEmiettement                    : this._solLegerEmiettement,
        _generalRappuyageLigne                  : this._generalRappuyageLigne,
        _generalInsCollage                      : this._generalInsCollage,
        _generalInsPierres                      : this._generalInsPierres,
        _generalNivellement                     : this._generalNivellement,
        _generalCtrlProf                        : this._generalCtrlProf,
        _generalRappuyage                       : this._generalRappuyage,
        _generalRoulage                         : this._generalRoulage,
        _generalEmiettement                     : this._generalEmiettement,
    };

    /**
     *  Get Instance
     */
    public static get instance(): RouleauNoteMeta {
        return this._instance;
    }

    /**
     *  Get Class Entity
     */
    public get classEntity(): new(...args: any[]) => RouleauNote {
        return this._classEntity;
    }

    /**
     *  Get Table Name
     */
    public get tableName(): string {
        return this._tableName;
    }

    /**
     *  Get syncDataServerToClient
     */
    public get syncDataServerToClient(): boolean {
        return this._syncDataServerToClient;
    }

    /**
     *  Get syncDataClientToServer
     */
    public get syncDataClientToServer(): boolean {
        return this._syncDataClientToServer;
    }

    /**
     *  Get syncFileServerToClient
     */
    public get syncFileServerToClient(): boolean {
        return this._syncFileServerToClient;
    }

    /**
     *  Get syncFileClientToServer
     */
    public get syncFileClientToServer(): boolean {
        return this._syncFileClientToServer;
    }

    /**
     *  Get uuid
     */
    public get uuid(): MetaColumn {
        return this._uuid;
    }

    /**
     *  Get status
     */
    public get status(): MetaColumn {
        return this._status;
    }

    /**
     *  Get timeStamp
     */
    public get timeStamp(): MetaColumn {
        return this._timeStamp;
    }

    /**
     *  Get __previousServerId
     */
    public get __previousServerId(): MetaColumn {
        return this.___previousServerId;
    }

    /**
     *  Get __isNew
     */
    public get __isNew(): MetaColumn {
        return this.___isNew;
    }

    /**
     *  Get uuidIndex
     */
    public get uuidIndex(): MetaIndex {
        return this._uuidIndex;
    }


    /**
     *  Get columns
     */
    public get columns(): { [p: string]: MetaColumn } {
        return this._columns;
    }


    /**
     *  Getter Code Rouleau Meta
     */
    public get codeRouleau(): MetaColumn {
        return this._codeRouleau;
    }

    /**
     *  Getter Note sol lourd rappuyage en ligne Meta
     */
    public get solLourdRappuyageLigne(): MetaColumn {
        return this._solLourdRappuyageLigne;
    }

    /**
     *  Getter Note sol lourd insensible aucollage Meta
     */
    public get solLourdInsCollage(): MetaColumn {
        return this._solLourdInsCollage;
    }

    /**
     *  Getter Note sol lourd insensible aux pierres Meta
     */
    public get solLourdInsPierres(): MetaColumn {
        return this._solLourdInsPierres;
    }

    /**
     *  Getter Note sol lourd nivellement Meta
     */
    public get solLourdNivellement(): MetaColumn {
        return this._solLourdNivellement;
    }

    /**
     *  Getter Note sol lourd contrôle profondeur Meta
     */
    public get solLourdCtrlProf(): MetaColumn {
        return this._solLourdCtrlProf;
    }

    /**
     *  Getter Note sol lourd rappuyage Meta
     */
    public get solLourdRappuyage(): MetaColumn {
        return this._solLourdRappuyage;
    }

    /**
     *  Getter Note sol lourd roulage Meta
     */
    public get solLourdRoulage(): MetaColumn {
        return this._solLourdRoulage;
    }

    /**
     *  Getter Note sol lourd emiettement Meta
     */
    public get solLourdEmiettement(): MetaColumn {
        return this._solLourdEmiettement;
    }

    /**
     *  Getter Note sol moyen rappuyage en ligne Meta
     */
    public get solMoyenRappuyageLigne(): MetaColumn {
        return this._solMoyenRappuyageLigne;
    }

    /**
     *  Getter Note sol moyen insensible aucollage Meta
     */
    public get solMoyenInsCollage(): MetaColumn {
        return this._solMoyenInsCollage;
    }

    /**
     *  Getter Note sol moyen insensible aux pierres Meta
     */
    public get solMoyenInsPierres(): MetaColumn {
        return this._solMoyenInsPierres;
    }

    /**
     *  Getter Note sol moyen nivellement Meta
     */
    public get solMoyenNivellement(): MetaColumn {
        return this._solMoyenNivellement;
    }

    /**
     *  Getter Note sol moyen contrôle profondeur Meta
     */
    public get solMoyenCtrlProf(): MetaColumn {
        return this._solMoyenCtrlProf;
    }

    /**
     *  Getter Note sol moyen rappuyage Meta
     */
    public get solMoyenRappuyage(): MetaColumn {
        return this._solMoyenRappuyage;
    }

    /**
     *  Getter Note sol moyen roulage Meta
     */
    public get solMoyenRoulage(): MetaColumn {
        return this._solMoyenRoulage;
    }

    /**
     *  Getter Note sol moyen emiettement Meta
     */
    public get solMoyenEmiettement(): MetaColumn {
        return this._solMoyenEmiettement;
    }

    /**
     *  Getter Note sol léger rappuyage en ligne Meta
     */
    public get solLegerRappuyageLigne(): MetaColumn {
        return this._solLegerRappuyageLigne;
    }

    /**
     *  Getter Note sol léger insensible aucollage Meta
     */
    public get solLegerInsCollage(): MetaColumn {
        return this._solLegerInsCollage;
    }

    /**
     *  Getter Note sol léger insensible aux pierres Meta
     */
    public get solLegerInsPierres(): MetaColumn {
        return this._solLegerInsPierres;
    }

    /**
     *  Getter Note sol léger nivellement Meta
     */
    public get solLegerNivellement(): MetaColumn {
        return this._solLegerNivellement;
    }

    /**
     *  Getter Note sol léger contrôle profondeur Meta
     */
    public get solLegerCtrlProf(): MetaColumn {
        return this._solLegerCtrlProf;
    }

    /**
     *  Getter Note sol léger rappuyage Meta
     */
    public get solLegerRappuyage(): MetaColumn {
        return this._solLegerRappuyage;
    }

    /**
     *  Getter Note sol léger roulage Meta
     */
    public get solLegerRoulage(): MetaColumn {
        return this._solLegerRoulage;
    }

    /**
     *  Getter Note sol léger emiettement Meta
     */
    public get solLegerEmiettement(): MetaColumn {
        return this._solLegerEmiettement;
    }

    /**
     *  Getter Note moyenne rappuyage en ligne Meta
     */
    public get generalRappuyageLigne(): MetaColumn {
        return this._generalRappuyageLigne;
    }

    /**
     *  Getter Note moyenne insensible aucollage Meta
     */
    public get generalInsCollage(): MetaColumn {
        return this._generalInsCollage;
    }

    /**
     *  Getter Note moyenne insensible aux pierres Meta
     */
    public get generalInsPierres(): MetaColumn {
        return this._generalInsPierres;
    }

    /**
     *  Getter Note moyenne nivellement Meta
     */
    public get generalNivellement(): MetaColumn {
        return this._generalNivellement;
    }

    /**
     *  Getter Note moyenne contrôle profondeur Meta
     */
    public get generalCtrlProf(): MetaColumn {
        return this._generalCtrlProf;
    }

    /**
     *  Getter Note moyenne rappuyage Meta
     */
    public get generalRappuyage(): MetaColumn {
        return this._generalRappuyage;
    }

    /**
     *  Getter Note moyenne roulage Meta
     */
    public get generalRoulage(): MetaColumn {
        return this._generalRoulage;
    }

    /**
     *  Getter Note moyenne emiettement Meta
     */
    public get generalEmiettement(): MetaColumn {
        return this._generalEmiettement;
    }


}

